import React from 'react';

const Home = () => {
  return (
    <section className="flex flex-col items-center justify-center h-screen text-center p-5 bg-gray-100">
      <div className="text-5xl font-bold mb-5">Error 404 - Page Not Found</div>
    </section>
  );
};

export default Home;
